"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subClass = void 0;
exports.subClass = new Map([
    [1, 2],
    [2, 2],
    [11, 2],
    [12, 2],
    [13, 2],
    [14, 1],
    [15, 1],
    [26, 2],
    [34, 2],
    [35, 2],
    [49, 2],
    [51, 2],
    [52, 2],
    [53, 2],
    [54, 2],
    [55, 2],
    [56, 2],
    [60, 1],
    [61, 2],
    [100, 2],
    [119, 2],
    [123, 2],
    [124, 2],
    [125, 2],
    [126, 2],
    [127, 2],
    [128, 2]
]);
